import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { OwnerCenter } from './pages/OwnerCenter';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { PixelRouteTracker } from './components/PixelRouteTracker';
import { SiteMeta } from './components/SiteMeta';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3iiwf2oflbi38">
      <ScrollToHash data-id="element-1" data-mp="3ijfu9xduvsdk" />
      <PixelRouteTracker data-id="element-2" data-mp="3ihuyy5jpw5en" />
      <SiteMeta data-id="element-3" data-mp="3mlaxj7fckftz" />
      <Routes data-id="element-4" data-mp="3mkrchhuehbbq">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-6" data-mp="3mj6lg27aoaim" />} data-id="element-5" data-mp="3mk868ye44bdj" />
        <Route path="/verify" element={<Authenticity data-id="element-8" data-mp="6htxpd5ixiv" />} data-id="element-7" data-mp="3relvsk63foaa" />
        <Route path="/rewards" element={<CrewRewards data-id="element-10" data-mp="82ohezguggq" />} data-id="element-9" data-mp="4n725ibkvc5" />
        <Route path="/activate" element={<Activate data-id="element-12" data-mp="2zmepodo7rua5" />} data-id="element-11" data-mp="2zld1r8m3ndb0" />
        <Route path="/owner" element={<OwnerCenter data-id="element-14" data-mp="33movnqc0akp0" />} data-id="element-13" data-mp="2zmwggus3xgao" />
        <Route path="/guide" element={<Guide data-id="element-16" data-mp="33n6yj5t6bx5w" />} data-id="element-15" data-mp="33lwywc6oagx5" />
        <Route path="/track" element={<TrackOrder data-id="element-18" data-mp="38m1e7yvuh5ls" />} data-id="element-17" data-mp="33orjc3pos1qk" />
        <Route path="/legal/:slug" element={<Legal data-id="element-20" data-mp="38kgocmkh6au9" />} data-id="element-19" data-mp="38kqc03i1s5ws" />
        <Route path="*" element={<Legal data-id="element-22" data-mp="3dle30p6a0mr0" />} data-id="element-21" data-mp="3dkuv81acbeqp" />
      </Routes>
    </BrowserRouter>;
}